import React from 'react';
import './about.css';

export const About = () => {
  return (
    <section className="about-section" id="about">
      <h2>Om mig</h2>
      <p>
        Jag är en engagerad <strong>Software Engineer</strong> med erfarenhet inom 
        både <strong>frontend och backend</strong>. Jag gillar att kombinera teknik, logik och 
        design för att skapa användarvänliga och skalbara lösningar.
      </p>
      <p>
        Mina främsta språk och ramverk är <strong>C++, Java, JavaScript, React, Node.js</strong> 
        och <strong>MongoDB</strong>. Jag har även arbetat med <strong>Fortran</strong> och 
        <strong> Ada</strong> inom flygsystemutveckling.
      </p>
    </section>
  );
};
